import React from 'react';
import { ChannelCallback } from './ChannelCallback';

/** /auth/threads/callback — the shared sign-in callback (ChannelCallback) for Threads. */
const ThreadsCallback: React.FC = () => <ChannelCallback platform="threads" />;

export default ThreadsCallback;
